import Profile from '../components/User/Profile'
import ProfileEdit from '../components/User/ProfileEdit'
import ProfileEditMail from '../components/User/ProfileEditMail'
import ProfileEditPassword from '../components/User/ProfileEditPassword'
import ProfileEditInvoice from '../components/User/ProfileEditInvoice'
import SubscriptionCancellation from '../components/User/SubscriptionCancellation'
import SettlementMethodChange from '../components/User/SettlementMethodChange'
import UsageStatement from '../components/User/UsageStatement'
import AccountWithdrawal from '../components/User/AccountWithdrawal'
import BankProfileEdit from '../components/User/BankEdit'

export default [
  {
    path: '/client/user/profile',
    name: 'profile',
    component: Profile,
    meta: {
      sideMenuId: 'profile',
    },
  },
  {
    path: '/client/user/profile-new',
    name: 'profile-new',
    props: {
      isNew: true,
    },
    component: ProfileEdit,
  },
  {
    path: '/client/user/profile-edit',
    name: 'profile-edit',
    component: ProfileEdit,
  },
  {
    path: '/client/user/profile-edit-mail',
    name: 'profile-edit-mail',
    component: ProfileEditMail,
  },
  {
    path: '/client/user/profile-edit-password',
    name: 'profile-edit-password',
    component: ProfileEditPassword,
  },
  {
    path: '/client/user/profile-edit-invoice',
    name: 'profile-edit-invoice',
    component: ProfileEditInvoice,
  },
  {
    path: '/client/user/subscription-cancellation',
    name: 'subscription-cancellation',
    component: SubscriptionCancellation,
  },
  {
    path: '/client/user/settlement-method-change',
    name: 'settlement-method-change',
    component: SettlementMethodChange,
  },
  {
    path: '/client/user/usage-statement',
    name: 'usage-statement',
    component: UsageStatement,
  },
  {
    path: '/client/user/bank',
    name: 'bank-edit',
    component: BankProfileEdit,
  },
  {
    path: '/client/user/withdrawal',
    name: 'account-withdrawal',
    component: AccountWithdrawal,
  },
]
